{
  "common": {
    "close": "Close",
    "save": "Save",
    "authorise_access": "Authorise access to {partner}",
    "send_invite_label": "Send customers an invite email when activated in {partner}",
    "send_invite_description": "This will send them an email asking them to confirm their account."
  },
  "sufio": {
    "description": "Your Sufio integration has been activated and will now allow customers to view and download their invoices. There are a few more steps to complete your configuration.",
    "follow_our_guide": "Follow our guide"
  },
  "linnworks": {
    "description": "Configure your Linnworks integration.",
    "token_label": "Token"
  },
  "intuitive_shipping": {
    "description": "Configure your Intuitive Shipping integration.",
    "api_key_label": "API Key",
    "api_key_placeholder": "Not shown for security reasons",
    "api_key_tooltip": "The API key can be found on the Partner integrations page within the Intuitive Shipping app.",
    "enable_sparklayer_shipping_alert": "To ensure no platform shipping methods are shown to the customer, please enable SparkLayer Shipping."
  },
  "katana": {
    "description": "Configure your Katana integration.",
    "intro": "To get started, you'll need to authorise SparkLayer to access your Katana account."
  },
  "brightpearl": {
    "description": "Configure your Brightpearl integration.",
    "intro": "To get started, you'll need to authorise SparkLayer to access your Brightpearl account.",
    "account_id_label": "Your Brightpearl Account ID",
    "connected_to": "Currently connected to {account}.",
    "customer_tag_label": "Tagged customers to synchronise",
    "exempt_codes_label": "Tax codes to set as exempt"
  },
  "cin7": {
    "description": "Configure your Cin7 Core integration.",
    "account_id": {
      "label": "Account ID",
      "placeholder": "Unique identifier for your Cin7 Core account",
      "tooltip": "Generated when creating a new application called 'SparkLayer' within your Cin7 Core account."
    },
    "api_key": {
      "label": "API Key",
      "placeholder": "Not shown for security reasons",
      "tooltip": "Secure authentication token created alongside the Account ID for authorized access to your Cin7 Core data."
    },
    "customer_tag": {
      "label": "Customer Sync Tags",
      "placeholder": "e.g: b2b, wholesale, vip",
      "description": "Only customers with these tags will be imported to your store."
    },
    "additional_tags": {
      "label": "Additional Customer Tags",
      "placeholder": "e.g: high-priority, vip",
      "description": "If an imported customer has any of these tags: they will also have those tags in your store."
    },
    "exempt_codes": {
      "label": "Tax-Exempt Codes",
      "placeholder": "e.g: TAXFREE, EXEMPT, NONTAXABLE",
      "tooltip": "Customers with these codes will be synced as tax-exempt in your store."
    },
    "send_invite_label": "Send customers an invite email when activated in Cin7 Core",
    "disable_child": {
      "label": "Ignore Non-Default Contacts",
      "description": "This will only sync the Default Contact of customers in Cin7."
    }
  },
  "unleashed": {
    "description": "Configure your Unleashed integration.",
    "api_id": {
      "label": "API ID",
      "placeholder": "Unique identifier for your Unleashed account",
      "tooltip": "Found in Unleashed admin under Integration, Unleashed API Access"
    },
    "api_key": {
      "label": "API Key",
      "placeholder": "Not shown for security reasons",
      "tooltip": "Secure token for API access, found in Unleashed admin"
    },
    "customer_types": {
      "label": "Customer Types",
      "placeholder": "e.g: Trade - Testing, Trade",
      "tooltip": "Customer types to sync to your store. Only customers with these types will be imported and assigned to matching SparkLayer groups."
    },
    "price_lists": {
      "label": "Price Lists",
      "placeholder": "e.g: sale, wholesale",
      "tooltip": "Unleashed price lists to set as highest priority for all customer groups. These will override default pricing for synced customers."
    },
    "send_invite_label": "Send customers an invite email when activated in Unleashed",
    "configure_currency": {
      "label": "Configure Sell Price Tier currency codes",
      "description": "Have a multi-currency store? Configure the expected currency codes for each sell price tier."
    },
    "currency_blank_note": "Leaving a tier blank will use your store's default currency code.",
    "tier_currency_code_label": "Tier {tier} Currency Code"
  },
  "xero": {
    "description": "Configure your Xero integration.",
    "take_payment": {
      "label": "Take payment using Xero",
      "description": "When enabled: transaction events from your store will be ignored."
    },
    "contacts": {
      "title": "Contacts",
      "description": "The contact matching process prioritises the Accounting ID (recommended) and falls back to email."
    },
    "auto_contact_creation": {
      "label": "Automatic contact creation",
      "enabled": {
        "label": "Enabled",
        "description": "Create a new contact in Xero if no match is found when syncing an invoice"
      },
      "disabled": {
        "label": "Disabled",
        "description": "Do not create a new contact in Xero if no match is found when syncing an invoice"
      }
    },
    "invoices": {
      "title": "Invoices",
      "default_line_item_account_code": {
        "label": "Default line item account code",
        "description": "The default account code to attribute line items to in Xero when creating invoices"
      },
      "shipping_line_account_code": {
        "label": "Shipping line account code",
        "description": "The account code to use for any shipping line items, leaving this empty will default to the default line item account code"
      },
      "payment_on_account": {
        "label": "Invoice creation for \"Payment on Account\" orders",
        "on_order": {
          "label": "On order",
          "description": "Create a invoice when an order is completed"
        },
        "on_shipment": {
          "label": "On shipment",
          "description": "Create a invoice when an order or package is shipped"
        }
      }
    },
    "line_item_mapping": {
      "title": "Invoice Line Item Mapping",
      "use_item_codes": {
        "label": "Map line items to item codes",
        "description": "When enabled, match invoice line items to an item (product) in Xero by SKU."
      },
      "tracking": {
        "label": "Tracking categories",
        "description": "The tracking category / categories to map line items to."
      }
    }
  },
  "quickbooks": {
    "description": "Configure your QuickBooks integration.",
    "take_payment": {
      "label": "Take payment using QuickBooks",
      "description": "When enabled: transaction events from your store will be ignored."
    },
    "customers": {
      "title": "Customers",
      "auto_contact_creation": {
        "label": "Automatic Contact Creation",
        "description": "The contact matching process prioritises the Accounting ID (recommended) and falls back to email."
      },
      "enabled": {
        "label": "Enabled",
        "description": "Create new contacts in QuickBooks when no match is found"
      },
      "disabled": {
        "label": "Disabled",
        "description": "New contacts will need to be manually created when no match is found"
      }
    },
    "invoices": {
      "title": "Invoices",
      "payment_on_account": {
        "label": "Payment on account - Invoice creation trigger",
        "on_order": {
          "label": "On order",
          "description": "Create an invoice when an order is created"
        },
        "on_shipment": {
          "label": "On shipment",
          "description": "Create an invoice when an order is shipped or part-shipped"
        }
      },
      "sales_receipts": {
        "label": "Enable Sales Receipts",
        "description": "Create a sales receipt for upfront payment orders"
      },
      "auto_send_email": {
        "label": "Auto-send invoices and sales receipts",
        "description": "Automatically email invoices and sales receipts to the customer from QuickBooks when they are created"
      }
    },
    "accounts": {
      "title": "Accounts",
      "income_account": {
        "label": "Income Account Name",
        "description": "If using custom line items, the name of the income account that should be used"
      }
    },
    "tax": {
      "title": "Tax",
      "shipping_tax": {
        "label": "Shipping Tax code",
        "description": "Name of the tax code that should be used for shipping lines (if tax is enabled)"
      },
      "exemption_tax": {
        "label": "Tax Exemption Tax code",
        "description": "Name of the tax code that will be applied to invoice lines for tax exempt users"
      }
    },
    "connect": "Connect to QuickBooks"
  }
}
